Basic information to identify and reference a specific organization.
